import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { NotificationService } from '../../../core/services/notification.service';
import { MessageService } from '../../../core/services/message.service';
import { Router } from "@angular/router";
export interface NoticeOption {
  id: number;
  title: string;
  sent_time: string;
  content: string;
  template_id: string;
}

@Component({
  selector: 'app-user-news',
  templateUrl: './user-news.component.html',
  styleUrls: ['./user-news.component.scss']
})
export class UserNewsComponent implements OnInit {
  public page: number;//当前页
  public pagination: number;
  public activeID: number;//当前active
  public noticeList: NoticeOption[] = [];
  // testStr: string = `您好，我是<a href="/job/company/38" target="_blank">深圳易思博软件有限公司</a>的招聘负责人，看了您的简历后， 觉得您的简历与我们正在招聘的岗位            <a routerLink="/job/detail/75">java软件工程师</a>匹配度比较高，希望邀请您来公司面谈
  //             <div class="news-items-down-btn">
  //               <a (click)="redirectTo("templateID")">前往处理</a>
  //             </div>`;
  constructor(
    public _notificationService: NotificationService,
    private _router: Router,
    public _msg: MessageService
  ) { }

  ngOnInit() {
    //获取消息列表
    this.getNoticeList();
    //将消息改为已读
    this.isreaded();
  }
  //获取消息列表
  getNoticeList() {
    this.noticeList = [];
    this._notificationService.getList(this.page).then(resp => {
      if (resp.success && resp['data'].length > 0) {
        resp['data'].map(rec => {
          // console.log(rec['outbox']);
          this.noticeList.push({
            id: parseInt(rec.id),
            title: rec['outbox'] ? rec['outbox']['title'] : '',
            sent_time: rec['outbox'] ? rec['outbox']['sent_time'] : '',
            content: rec['outbox'] ? rec['outbox']['content'] : '',
            template_id: rec['outbox'] ? rec['outbox']['template_id'] : ''
          })
        });
        this.pagination = resp['pagination']['pageCount'];
        this.page = resp['pagination']['currentPage'];
      } else {
        this.noticeList = [];
      }
    })
  }
  rendererPart(dom: ElementRef, content: string) {
    // console.log(dom);
  }
  //将消息改为已读
  isreaded() {
    this._notificationService.setReadedAll().then(resp => {
      // console.log(resp);
    });
  }
  //前往处理
  linkTo(event) {
    switch (event) {
      case "invitation":  //面试邀请
        this._router.navigate(['/user/student/interview-notice']);
        break;
      case "interview_info":  //面试信息
        break;
      case "course_buy":  //课程购买
        this._router.navigate(['/station/coudetail/']);
        break;
    }
  }
  //删除通知
  deleteItem(did: number) {
    this._notificationService.delete(did).then(resp => {
      if (resp['data'] > 0) {
        this.getNoticeList();//获取消息列表
      } else {
        this._msg.warn("删除失败");
        setTimeout(() => { this._msg.clear(); }, 3000);
      }
    })
  }

  enterInterview(did: number) {
    this.activeID = did;
  }
  leaveInterview() {
    this.activeID = null;
  }
  paginate(event) {
    if (this.page !== event['page'] + 1) {
      this.page = event['page'] + 1;
      this.getNoticeList(); //获取面试邀请列表
    }
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/user-news/user-news.component.ts